(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-trust-videos"] && !Shopify.designMode) return;
  try {
    
  function htSocialSource(raw) {
    try {
      const url = new URL(raw);
      if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
      const host = url.hostname.toLowerCase().replace(/^www\./, '');
      const parts = url.pathname.split('/').filter(Boolean);
      if (host === 'youtu.be' || host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
        const id = host === 'youtu.be' ? parts[0] : parts[0] === 'watch' ? url.searchParams.get('v') : ['shorts', 'embed', 'live'].includes(parts[0]) ? parts[1] : null;
        return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? { platform: 'youtube', id: id, url: 'https://www.youtube.com/watch?v=' + id } : null;
      }
      if (host === 'instagram.com') {
        const at = parts.findIndex(part => part === 'reel' || part === 'p' || part === 'tv');
        const id = at >= 0 ? parts[at + 1] : null;
        return /^[A-Za-z0-9_-]+$/.test(id || '') ? { platform: 'instagram', id: id, url: 'https://www.instagram.com/' + (parts[at] === 'tv' ? 'p' : parts[at]) + '/' + id + '/' } : null;
      }
    } catch (error) {}
    return null;
  }
  let htInstagramLoader;
  function htLoadInstagram() {
    if (window.instgrm && window.instgrm.Embeds) return Promise.resolve(window.instgrm);
    if (!htInstagramLoader) {
      htInstagramLoader = new Promise((resolve, reject) => {
        let script = document.querySelector('script[data-ht-instagram-loader]');
        if (!script) {
          script = document.createElement('script');
          script.async = true;
          script.src = 'https://www.instagram.com/embed.js';
          script.dataset.htInstagramLoader = 'true';
          document.head.appendChild(script);
        }
        script.addEventListener('load', () => window.instgrm && window.instgrm.Embeds ? resolve(window.instgrm) : reject(new Error('Embed unavailable')), { once: true });
        script.addEventListener('error', reject, { once: true });
      });
    }
    return htInstagramLoader;
  }
  // Only original cards: rotate a fully offscreen card and compensate its offset
  // in the same frame. This creates no duplicate media or focus targets.
  class HtVideoConveyor {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.ht-videos__grid');
      this.cards = Array.from(this.track.children);
      this.events = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.hover = false;
      this.held = false;
      this.selected = false;
      this.idleUntil = 0;
      this.remainder = 0;
      const on = (target, type, callback, options = {}) => target.addEventListener(type, callback, { ...options, signal: this.events.signal });
      this.wake = () => this.update();
      this.refreshMedia = () => {
        this.playing = Array.from(document.querySelectorAll('video')).some(video => !video.paused && !video.ended);
        this.update();
      };
      on(this.track, 'pointerenter', event => { if (event.pointerType !== 'touch') { this.hover = true; this.update(); } });
      on(this.track, 'pointerleave', () => { this.hover = false; this.update(); });
      on(this.track, 'focusin', this.wake);
      on(this.track, 'focusout', () => queueMicrotask(this.wake));
      on(this.track, 'pointerdown', () => { this.held = true; this.update(); }, { passive: true });
      const release = () => { if (this.held) { this.held = false; this.defer(); } };
      on(document, 'pointerup', release, { passive: true });
      on(document, 'pointercancel', release, { passive: true });
      on(window, 'blur', () => { this.held = false; this.hover = false; this.update(); });
      on(window, 'focus', this.wake);
      on(this.track, 'wheel', () => this.defer(), { passive: true });
      on(this.track, 'keydown', () => this.defer());
      on(document, 'visibilitychange', this.wake);
      ['play', 'pause', 'ended', 'emptied'].forEach(type => on(document, type, this.refreshMedia, { capture: true }));
      on(document, 'shopify:block:select', event => { if (section.contains(event.target)) { this.selected = true; this.update(); } });
      on(document, 'shopify:block:deselect', () => { this.selected = false; this.update(); });
      this.motion.addEventListener('change', this.wake);
      this.resize = new ResizeObserver(this.wake);
      this.resize.observe(this.track);
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0 });
      this.intersection.observe(this.track);
      // Native page dialogs, including the shared original video player.
      this.dialogs = new MutationObserver(records => {
        if (records.some(record => record.type === 'attributes' || Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node => node.nodeType === 1 && (node.matches('dialog') || node.querySelector('dialog'))))) this.update();
      });
      this.dialogs.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'], childList: true });
      this.refreshMedia();
    }
    defer() {
      this.idleUntil = performance.now() + 4000;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.wake, 4050);
      this.update();
    }
    canMove() {
      return this.visible && !document.hidden && document.hasFocus() && !this.motion.matches && !this.hover && !this.held && !this.selected && !this.playing && !this.track.contains(document.activeElement) && !document.querySelector('dialog[open]') && performance.now() >= this.idleUntil;
    }
    stride() {
      const first = this.track.children[0], second = this.track.children[1];
      return first && second ? second.getBoundingClientRect().left - first.getBoundingClientRect().left : 0;
    }
    update() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.last = 0;
      const stride = this.stride();
      // A short track stays manually scrollable; never expose an empty tail.
      if (!this.canMove() || stride <= 0 || this.track.scrollWidth - this.track.clientWidth < Math.floor(stride)) return;
      this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      this.frame = null;
      if (!this.canMove()) { this.last = 0; return; }
      const stride = this.stride();
      if (stride <= 0 || this.track.scrollWidth - this.track.clientWidth < Math.floor(stride)) { this.last = 0; return; }
      if (this.last) {
        this.remainder += Math.min(time - this.last, 64) * 18 / 1000;
        const pixels = Math.floor(this.remainder);
        this.remainder -= pixels;
        // Normalize any manual position before the next small automatic step.
        this.rotate(stride);
        this.track.scrollLeft += pixels;
        this.rotate(stride);
      }
      this.last = time;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    rotate(stride) {
      let remaining = this.cards.length;
      // scrollLeft/scrollWidth can be rounded by the browser at fractional widths.
      while (this.track.scrollLeft >= Math.floor(stride) && remaining-- > 0) {
        const offset = this.track.scrollLeft;
        this.track.appendChild(this.track.firstElementChild);
        this.track.scrollLeft = Math.max(0, offset - stride);
      }
    }
    destroy() {
      this.events.abort();
      this.motion.removeEventListener('change', this.wake);
      this.resize.disconnect();
      this.intersection.disconnect();
      this.dialogs.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.cards.forEach(card => this.track.appendChild(card));
    }
  }

  if (!customElements.get('home-trust-videos')) {
    customElements.define('home-trust-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-ht-social]');
          if (button && this.contains(button)) this.openVideo(button);
        }, { signal: (this.videoEvents = new AbortController()).signal });
        if (this.hasAttribute('data-auto-scroll')) this.conveyor = new HtVideoConveyor(this);
      }
      disconnectedCallback() {
        if (this.videoEvents) this.videoEvents.abort();
        if (this.conveyor) this.conveyor.destroy();
        delete this.dataset.bound;
      }
      openVideo(button) {
        const source = htSocialSource(button.dataset.htSocial);
        if (!source) return;
        let dialog = document.getElementById('ht-home-video-player');
        if (dialog) dialog.remove();
        dialog = document.createElement('dialog');
        dialog.id = 'ht-home-video-player';
        dialog.className = 'ht-player';
        const head = document.createElement('div');
        head.className = 'ht-player__head';
        const title = document.createElement('h2');
        title.id = 'ht-home-video-title';
        title.textContent = button.dataset.title;
        dialog.setAttribute('aria-labelledby', title.id);
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'ht-player__close';
        close.textContent = this.dataset.closeLabel;
        close.addEventListener('click', () => dialog.close());
        head.append(title, close);
        const body = document.createElement('div');
        body.className = 'ht-player__body';
        const foot = document.createElement('div');
        foot.className = 'ht-player__foot';
        const original = document.createElement('a');
        original.href = source.url;
        original.target = '_blank';
        original.rel = 'noopener noreferrer';
        original.textContent = this.dataset.originalLabel + ' — ' + (source.platform === 'youtube' ? 'YouTube' : 'Instagram');
        const notice = document.createElement('p');
        notice.className = 'ht-player__notice';
        notice.setAttribute('role', 'status');
        notice.hidden = true;
        notice.textContent = this.dataset.unavailableLabel;
        foot.append(original, notice);
        dialog.append(head, body, foot);
        document.body.appendChild(dialog);
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        let observer, timer;
        dialog.addEventListener('close', () => {
          if (observer) observer.disconnect();
          if (timer) clearTimeout(timer);
          body.replaceChildren();
          if (document.body.style.overflow === 'hidden') document.body.style.overflow = previousOverflow;
          button.focus();
          dialog.remove();
        }, { once: true });
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog.showModal();
        if (source.platform === 'youtube') {
          const frame = document.createElement('div');
          frame.className = 'ht-player__frame' + (button.dataset.orientation === 'portrait' ? ' ht-player__frame--portrait' : '');
          const iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + source.id + '?autoplay=1&rel=0';
          iframe.title = button.dataset.title;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.appendChild(iframe);
          body.appendChild(frame);
        } else {
          const embed = document.createElement('div');
          embed.className = 'ht-player__instagram';
          const blockquote = document.createElement('blockquote');
          blockquote.className = 'instagram-media';
          blockquote.setAttribute('data-instgrm-permalink', source.url);
          blockquote.setAttribute('data-instgrm-version', '14');
          const link = document.createElement('a');
          link.href = source.url;
          link.textContent = this.dataset.originalLabel + ' — Instagram';
          blockquote.appendChild(link);
          embed.appendChild(blockquote);
          body.appendChild(embed);
          const bodyStyle = getComputedStyle(body);
          const availableWidth = body.clientWidth - parseFloat(bodyStyle.paddingLeft) - parseFloat(bodyStyle.paddingRight);
          if (availableWidth < 326) { body.replaceChildren(); notice.hidden = false; return; }
          observer = new MutationObserver(() => {
            if (embed.querySelector('iframe')) { clearTimeout(timer); observer.disconnect(); }
          });
          observer.observe(embed, { childList: true, subtree: true });
          timer = setTimeout(() => { if (dialog.open && !embed.querySelector('iframe')) notice.hidden = false; }, 12000);
          htLoadInstagram().then(instagram => { if (dialog.open) instagram.Embeds.process(); }).catch(() => { if (dialog.open) notice.hidden = false; });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb31-mcb-trip"] && !Shopify.designMode) return;
  try {
    
(() => {
function initializeDecisionTool({ rootSelector, decide }) {
  const root = document.querySelector(rootSelector);
  if (!root || root.dataset.sbncInitialised === "true") return;
  root.dataset.sbncInitialised = "true";
  const form = root.querySelector("[data-form]");
  const empty = root.querySelector("[data-empty]");
  const result = root.querySelector("[data-result]");
  const live = root.querySelector("[data-live]");

  function list(items) {
    return items.map((item) => {
      const node = document.createElement("li");
      node.textContent = item;
      return node;
    });
  }

  function render(answer) {
    const status = result.querySelector("[data-status]");
    status.textContent = answer.status;
    status.dataset.tone = answer.tone;
    result.querySelector("[data-title]").textContent = answer.title;
    result.querySelector("[data-summary]").textContent = answer.summary;
    const stop = result.querySelector("[data-stop]");
    stop.hidden = !answer.stop?.length;
    stop.querySelector("ul").replaceChildren(...list(answer.stop || []));
    result.querySelector("[data-actions]").replaceChildren(...list(answer.actions));
    result.querySelector("[data-checks]").replaceChildren(...list(answer.checks));
    empty.hidden = true;
    result.hidden = false;
    live.textContent = `${answer.status}. ${answer.title}`;
    result.querySelector("[data-title]").focus({ preventScroll: true });
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    render(decide(Object.fromEntries(new FormData(form))));
  });

  root.querySelector("[data-reset]").addEventListener("click", () => {
    form.reset();
    result.hidden = true;
    empty.hidden = false;
    live.textContent = "Tool reset.";
    form.querySelector("select, input")?.focus();
  });
}

const result = (status, tone, title, summary, actions, checks, stop = []) => ({ status, tone, title, summary, actions, checks, stop });

function diagnoseTrip(input) {
  const { danger, device, scope, timing } = input;
  if ([danger, device, scope, timing].some((value) => !value)) throw new Error("Answer every question before viewing the result.");

  if (danger !== "none") {
    return result(
      "Stop now",
      "danger",
      "Treat this as an electrical emergency",
      "The visible warning sign is more important than identifying the breaker type.",
      ["Keep people away from the affected area.", "Use a licensed electrician or emergency service before restoring power."],
      ["Record what you saw and when it started, only from a safe distance."],
      ["Do not touch wet equipment, exposed wiring, the distribution board, or a person receiving a shock.", "Switch off the main supply only when it is safely accessible. Do not repeatedly reset the breaker."],
    );
  }

  if ((device === "rccb" || device === "rcbo") && (timing === "wet" || scope === "appliance")) {
    return result("Likely leakage path", "caution", "Earth leakage or an appliance fault needs isolation", "RCCB/RCBO operation commonly points to current leaking away from the intended circuit. This wizard cannot locate the fault.", ["Leave the affected circuit or appliance isolated.", "Ask an electrician to test insulation, earthing and the suspected appliance."], ["Note whether rain, moisture or one appliance consistently triggers the trip.", "Confirm the exact device label: RCCB, RCBO or MCB." ]);
  }

  if (timing === "high-load" && (device === "mcb" || device === "rcbo" || device === "unknown")) {
    return result("Overload pattern", "caution", "Too many simultaneous loads may be exceeding the circuit", "The timing fits an overload pattern, but loose connections, heat damage or a faulty appliance remain possible.", ["Keep high-power appliances off until the circuit is checked.", "Ask an electrician to compare connected load, cable rating and breaker rating."], ["Write down which appliances were running.", "Note whether the breaker trips after a repeatable delay." ]);
  }

  if (timing === "immediate") {
    return result("Fault pattern", "caution", "An immediate trip needs professional fault isolation", "A short circuit, failed appliance, damaged cable or earth leakage is possible. Repeated resetting can worsen damage.", ["Leave the affected load disconnected.", "Arrange qualified testing before another restart."], ["Note whether one appliance or one circuit causes the trip.", "Photograph the breaker label only if the board is closed and safe." ]);
  }

  if (scope === "pump" && timing === "delayed") {
    return result("Motor protection pattern", "caution", "The pump or motor may be overheating or overloading", "Possible causes include mechanical load, low or unstable voltage, cable loss, wrong protection setting or a motor fault. No cause is confirmed here.", ["Stop repeated restart attempts.", "Ask a technician to check supply, current, cable, starter and pump condition using the manufacturer data."], ["Record the delay before tripping and any sound or water-flow change.", "Keep the motor nameplate and starter model available." ]);
  }

  return result("Needs isolation", "info", "The pattern is not specific enough to name one cause", "Use the trip pattern to help a qualified electrician isolate supply, circuit, appliance and protection-device causes.", ["Keep the affected circuit off if the trip repeats.", "Arrange inspection instead of increasing the breaker rating."], ["Note the exact device label, affected area, timing and loads in use.", "Check whether the issue follows one appliance without opening electrical equipment." ]);
}

function boot() {
initializeDecisionTool({ rootSelector: '[data-sbnc-tool="mcb-rccb-trip-diagnosis-wizard"]', decide: diagnoseTrip });

}
boot();
document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb32-bill-decoder"] && !Shopify.designMode) return;
  try {
    
(() => {
function initializeDecisionTool({ rootSelector, decide }) {
  const root = document.querySelector(rootSelector);
  if (!root || root.dataset.sbncInitialised === "true") return;
  root.dataset.sbncInitialised = "true";
  const form = root.querySelector("[data-form]");
  const empty = root.querySelector("[data-empty]");
  const result = root.querySelector("[data-result]");
  const live = root.querySelector("[data-live]");

  function list(items) {
    return items.map((item) => {
      const node = document.createElement("li");
      node.textContent = item;
      return node;
    });
  }

  function render(answer) {
    const status = result.querySelector("[data-status]");
    status.textContent = answer.status;
    status.dataset.tone = answer.tone;
    result.querySelector("[data-title]").textContent = answer.title;
    result.querySelector("[data-summary]").textContent = answer.summary;
    const stop = result.querySelector("[data-stop]");
    stop.hidden = !answer.stop?.length;
    stop.querySelector("ul").replaceChildren(...list(answer.stop || []));
    result.querySelector("[data-actions]").replaceChildren(...list(answer.actions));
    result.querySelector("[data-checks]").replaceChildren(...list(answer.checks));
    empty.hidden = true;
    result.hidden = false;
    live.textContent = `${answer.status}. ${answer.title}`;
    result.querySelector("[data-title]").focus({ preventScroll: true });
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    render(decide(Object.fromEntries(new FormData(form))));
  });

  root.querySelector("[data-reset]").addEventListener("click", () => {
    form.reset();
    result.hidden = true;
    empty.hidden = false;
    live.textContent = "Tool reset.";
    form.querySelector("select, input")?.focus();
  });
}

const chargeMap = {
  fixed: { title: "Fixed or demand charge", summary: "Usually linked to connection type, sanctioned/contract load or tariff category—not only the units used.", checks: ["Compare the sanctioned load and tariff category with your connection records.", "Open the current tariff order for your own DISCOM and consumer category."] },
  energy: { title: "Energy or unit charge", summary: "This is the consumption component, normally based on billed units and the applicable tariff slabs.", checks: ["Compare previous and current meter readings.", "Check whether the bill uses actual, average or estimated reading."] },
  fuel: { title: "Fuel or power-purchase adjustment", summary: "Names such as FCA, FPPPA or FPPAS usually describe a regulator-approved adjustment that can change by period and utility.", checks: ["Match the charge period with the current utility notice or tariff order.", "Do not assume another state's percentage applies to your bill."] },
  duty: { title: "Electricity duty, cess or tax", summary: "This is a statutory charge whose basis depends on the state, consumer category and current rules.", checks: ["Verify the state rule and the calculation base shown on the bill.", "Check whether any exempt category applies through the official utility." ] },
  arrears: { title: "Arrears or delayed-payment charge", summary: "This may represent an unpaid earlier balance, delayed-payment surcharge, adjustment or corrected bill.", checks: ["Compare the previous receipt and bill ledger.", "Raise a written billing query if the amount is not traceable." ] },
  meter: { title: "Meter, security or other account charge", summary: "Meter rent, security-deposit adjustment and similar account charges are separate from appliance electricity use.", checks: ["Read the line description and billing notes.", "Check the utility's official schedule before disputing the amount." ] },
  subsidy: { title: "Subsidy, rebate or credit", summary: "A negative amount or credit reduces the payable bill, subject to the scheme and eligibility shown by the utility.", checks: ["Confirm the credit period and eligibility note.", "Do not treat a temporary credit as a permanent tariff reduction." ] },
  unknown: { title: "Unknown charge label", summary: "The label is not specific enough for a reliable explanation. Utility abbreviations are not consistent across India.", checks: ["Use the exact bill legend or tariff order for your DISCOM.", "Ask the utility to explain the charge in writing." ] },
};

function decodeCharge(input) {
  const item = chargeMap[input.charge];
  if (!item || !input.reading || !input.change) throw new Error("Choose the charge, meter-reading basis and bill change.");
  const actions = [...item.checks];
  if (input.change === "sudden" && input.units === "same") actions.unshift("Units appear similar, so compare new tariff, fixed load, adjustment, arrears and taxes line by line.");
  if (input.change === "sudden" && input.units === "higher") actions.unshift("First verify the billed-unit increase, reading dates and meter multiplier before blaming one charge.");
  if (input.reading === "average" || input.reading === "estimated") actions.unshift("The bill is not based on a confirmed actual reading; verify the meter-reading status first.");
  return { status: "Charge identified", tone: input.charge === "unknown" ? "caution" : "info", title: item.title, summary: item.summary, actions, checks: ["Use only your utility's current tariff and notices.", "Keep account number, address and QR/barcode out of screenshots shared publicly."], stop: [] };
}

function boot() {
initializeDecisionTool({rootSelector: '[data-sbnc-tool="electricity-bill-charge-decoder"]',decide:decodeCharge});

}
boot();
document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb33-cctv-offline"] && !Shopify.designMode) return;
  try {
    
(() => {
function initializeDecisionTool({ rootSelector, decide }) {
  const root = document.querySelector(rootSelector);
  if (!root || root.dataset.sbncInitialised === "true") return;
  root.dataset.sbncInitialised = "true";
  const form = root.querySelector("[data-form]");
  const empty = root.querySelector("[data-empty]");
  const result = root.querySelector("[data-result]");
  const live = root.querySelector("[data-live]");

  function list(items) {
    return items.map((item) => {
      const node = document.createElement("li");
      node.textContent = item;
      return node;
    });
  }

  function render(answer) {
    const status = result.querySelector("[data-status]");
    status.textContent = answer.status;
    status.dataset.tone = answer.tone;
    result.querySelector("[data-title]").textContent = answer.title;
    result.querySelector("[data-summary]").textContent = answer.summary;
    const stop = result.querySelector("[data-stop]");
    stop.hidden = !answer.stop?.length;
    stop.querySelector("ul").replaceChildren(...list(answer.stop || []));
    result.querySelector("[data-actions]").replaceChildren(...list(answer.actions));
    result.querySelector("[data-checks]").replaceChildren(...list(answer.checks));
    empty.hidden = true;
    result.hidden = false;
    live.textContent = `${answer.status}. ${answer.title}`;
    result.querySelector("[data-title]").focus({ preventScroll: true });
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    render(decide(Object.fromEntries(new FormData(form))));
  });

  root.querySelector("[data-reset]").addEventListener("click", () => {
    form.reset();
    result.hidden = true;
    empty.hidden = false;
    live.textContent = "Tool reset.";
    form.querySelector("select, input")?.focus();
  });
}

function diagnoseCctv(input) {
  const { system, scope, failure, power } = input;
  if ([system, scope, failure, power].some((value) => !value)) throw new Error("Answer every question before viewing the result.");
  let title = "Check power and recorder status first";
  let summary = "The answers do not isolate one confirmed fault. Work from power to cable/network to recorder, without factory-resetting equipment.";
  let actions = ["Confirm the recorder and network equipment are powered.", "Note the exact on-screen error and which cameras are affected."];

  if (failure === "mobile-only") {
    title = "The cameras may be working locally; remote access is the likely path";
    summary = "If local display or recording works, the problem is more likely internet, router, app login, time settings or recorder remote-access status—not the camera itself.";
    actions = ["Check whether the recorder has internet and correct date/time.", "Confirm the official app account and device status.", "Do not factory-reset a working recorder before exporting its configuration."];
  } else if (failure === "recording-only") {
    title = "Live video works, so inspect recording and storage settings";
    summary = "A full/failed drive, disabled schedule, wrong time or recorder fault can stop recording while live view remains available.";
    actions = ["Check recorder time, schedule and HDD status on the local monitor.", "Preserve needed footage before changing storage settings.", "Use the recorder manufacturer's exact manual for HDD warnings."];
  } else if (scope === "all" && power === "no") {
    title = "A shared power path is the first suspect";
    summary = "All cameras losing power points toward the recorder, PoE switch, SMPS, adapter, socket or upstream supply.";
    actions = ["Keep the system off if there is heat, smell or visible damage.", "Have the shared power supply and protection checked before replacing cameras."];
  } else if (scope === "one" && power === "no") {
    title = "Isolate the affected camera's power path";
    summary = "One unpowered camera usually narrows the issue to that camera, connector, cable, PoE port or SMPS channel.";
    actions = ["With power safely isolated, inspect accessible plugs and cable damage.", "Use a known-good port or supply only when the manufacturer procedure allows it.", "Do not expose outdoor joints to moisture."];
  } else if (system === "ip" && scope === "one") {
    title = "One IP/PoE camera may have a link, address or credential issue";
    summary = "Power alone does not confirm network communication. Link state, IP conflict, changed password or cable/PoE limits remain possible.";
    actions = ["Check the recorder's camera-status page and exact error.", "Verify link/PoE status using the recorder or switch interface.", "Do not reset credentials until configuration and ownership are confirmed."];
  } else if (system === "analog" && scope === "one") {
    title = "Check the single analog video and power channel";
    summary = "A loose BNC connector, cable fault, camera power channel or failed camera can remove one analog feed.";
    actions = ["Isolate power before touching connectors.", "Compare the affected channel with a known working channel using the manufacturer's procedure."];
  }

  return { status: "Likely fault path", tone: "info", title, summary, actions, checks: ["Record system brand/model, error text and when the failure started.", "Confirm whether local live view and recording still work before changing anything."], stop: [] };
}

function boot() {
initializeDecisionTool({rootSelector: '[data-sbnc-tool="cctv-offline-troubleshooting-wizard"]',decide:diagnoseCctv});

}
boot();
document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb34-solar-subsidy"] && !Shopify.designMode) return;
  try {
    
(() => {
function initializeDecisionTool({ rootSelector, decide }) {
  const root = document.querySelector(rootSelector);
  if (!root || root.dataset.sbncInitialised === "true") return;
  root.dataset.sbncInitialised = "true";
  const form = root.querySelector("[data-form]");
  const empty = root.querySelector("[data-empty]");
  const result = root.querySelector("[data-result]");
  const live = root.querySelector("[data-live]");

  function list(items) {
    return items.map((item) => {
      const node = document.createElement("li");
      node.textContent = item;
      return node;
    });
  }

  function render(answer) {
    const status = result.querySelector("[data-status]");
    status.textContent = answer.status;
    status.dataset.tone = answer.tone;
    result.querySelector("[data-title]").textContent = answer.title;
    result.querySelector("[data-summary]").textContent = answer.summary;
    const stop = result.querySelector("[data-stop]");
    stop.hidden = !answer.stop?.length;
    stop.querySelector("ul").replaceChildren(...list(answer.stop || []));
    result.querySelector("[data-actions]").replaceChildren(...list(answer.actions));
    result.querySelector("[data-checks]").replaceChildren(...list(answer.checks));
    empty.hidden = true;
    result.hidden = false;
    live.textContent = `${answer.status}. ${answer.title}`;
    result.querySelector("[data-title]").focus({ preventScroll: true });
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    render(decide(Object.fromEntries(new FormData(form))));
  });

  root.querySelector("[data-reset]").addEventListener("click", () => {
    form.reset();
    result.hidden = true;
    empty.hidden = false;
    live.textContent = "Tool reset.";
    form.querySelector("select, input")?.focus();
  });
}

const commonChecks = ["Recent electricity bill and the connection details shown on it.", "Identity, bank and ownership/consent records requested by the official portal.", "Only an empanelled vendor and system documents accepted by the applicable scheme." ];

function screenSolarSubsidy(input) {
  const { property, connection, roof, prior } = input;
  if ([property, connection, roof, prior].some((value) => !value)) throw new Error("Answer every question before viewing the result.");

  if (property === "commercial") return { status: "Different scheme path", tone: "caution", title: "The central residential subsidy path is not the normal route for this property", summary: "Commercial and industrial connections need the current state, DISCOM or other programme rules. Do not submit under a residential category.", actions: ["Check your DISCOM and state renewable-energy agency.", "Confirm connection category before requesting quotations."], checks: commonChecks, stop: [] };

  if (roof === "none" || connection === "none") return { status: "Prerequisite missing", tone: "caution", title: "Roof rights or an eligible electricity connection must be resolved first", summary: "The portal application must match a real premises, connection and authorised applicant. This tool cannot create eligibility through an informal arrangement.", actions: ["Obtain the property owner's written consent where applicable.", "Confirm the electricity connection and applicant relationship with the official portal or DISCOM."], checks: commonChecks, stop: [] };

  if (property === "tenant" && roof !== "permission") return { status: "Owner action required", tone: "caution", title: "A tenant needs the property owner's formal participation or permission", summary: "Paying the electricity bill does not by itself prove roof rights or subsidy eligibility.", actions: ["Discuss ownership, connection name and roof permission with the owner.", "Verify the accepted applicant arrangement on the official portal before paying a vendor."], checks: commonChecks, stop: [] };

  if (property === "society") return { status: "Group-housing route", tone: "info", title: "Use the group-housing or common-facility eligibility path", summary: "A housing society is not the same as one individual household application. Common-area load, authorised signatory and society approvals matter.", actions: ["Use the group-housing information on the national portal.", "Record the society resolution, common connection and authorised signatory."], checks: commonChecks, stop: [] };

  if (prior !== "none") return { status: "Official confirmation needed", tone: "caution", title: "A previous or uncertain subsidy record can change eligibility", summary: "Do not assume a second subsidy is allowed. The portal or DISCOM must confirm the earlier installation and connection history.", actions: ["Retrieve the earlier application or commissioning record.", "Ask the portal/DISCOM to confirm eligibility before paying a vendor."], checks: commonChecks, stop: [] };

  return { status: "Potentially ready", tone: "good", title: "The basic residential prerequisites appear present", summary: "This is not approval. Final eligibility, capacity, vendor, inspection and subsidy release are decided through the current official process.", actions: ["Register or sign in only at the official PM Surya Ghar portal.", "Select your state and DISCOM, then follow the live application checklist.", "Do not pay anyone promising guaranteed subsidy release."], checks: commonChecks, stop: [] };
}

function boot() {
initializeDecisionTool({rootSelector: '[data-sbnc-tool="solar-subsidy-eligibility-document-checklist"]',decide:screenSolarSubsidy});

}
boot();
document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb35-bee-label"] && !Shopify.designMode) return;
  try {
    
(() => {
function initializeDecisionTool({ rootSelector, decide }) {
  const root = document.querySelector(rootSelector);
  if (!root || root.dataset.sbncInitialised === "true") return;
  root.dataset.sbncInitialised = "true";
  const form = root.querySelector("[data-form]");
  const empty = root.querySelector("[data-empty]");
  const result = root.querySelector("[data-result]");
  const live = root.querySelector("[data-live]");

  function list(items) {
    return items.map((item) => {
      const node = document.createElement("li");
      node.textContent = item;
      return node;
    });
  }

  function render(answer) {
    const status = result.querySelector("[data-status]");
    status.textContent = answer.status;
    status.dataset.tone = answer.tone;
    result.querySelector("[data-title]").textContent = answer.title;
    result.querySelector("[data-summary]").textContent = answer.summary;
    const stop = result.querySelector("[data-stop]");
    stop.hidden = !answer.stop?.length;
    stop.querySelector("ul").replaceChildren(...list(answer.stop || []));
    result.querySelector("[data-actions]").replaceChildren(...list(answer.actions));
    result.querySelector("[data-checks]").replaceChildren(...list(answer.checks));
    empty.hidden = true;
    result.hidden = false;
    live.textContent = `${answer.status}. ${answer.title}`;
    result.querySelector("[data-title]").focus({ preventScroll: true });
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    render(decide(Object.fromEntries(new FormData(form))));
  });

  root.querySelector("[data-reset]").addEventListener("click", () => {
    form.reset();
    result.hidden = true;
    empty.hidden = false;
    live.textContent = "Tool reset.";
    form.querySelector("select, input")?.focus();
  });
}

function decodeBeeLabel(input) {
  const { category, period, stars, units, qr } = input;
  if (![category, period, stars, qr].every(Boolean)) throw new Error("Choose the appliance, label period, stars and QR status.");
  const actions = [];
  let tone = "info";
  if (qr === "verified") actions.push("Match the official record with the exact brand, model code, capacity and label period printed on the appliance.");
  if (qr === "failed") { tone = "caution"; actions.push("The QR result is not verified. Search the exact model in the official BEE system before relying on the label."); }
  if (qr === "unchecked") actions.push("Scan the label QR code with the official BEE Star Label app or use the official product search.");
  if (period === "unknown") { tone = "caution"; actions.push("Find the label-validity period. Star thresholds can change, so an old and new label are not directly comparable."); }
  if (!String(units || "").trim()) actions.push("Find annual energy consumption on the label; star count alone does not show expected yearly units.");
  actions.push("Compare only the same appliance category, capacity/size and label period.");
  return {
    status: qr === "verified" ? "Verification claimed" : "Verification pending",
    tone,
    title: `${stars}-star ${category} label`,
    summary: units ? `The label states ${units} annual units. This is a standardized label value, not a guarantee of your household consumption.` : "The star count indicates relative efficiency within its applicable category and label period; it does not reveal your actual electricity use by itself.",
    actions,
    checks: ["Exact brand and model code", "Capacity, size or rated output", "Label period and annual energy value", "Official BEE record or QR result"],
    stop: [],
  };
}

function boot() {
initializeDecisionTool({ rootSelector: '[data-sbnc-tool="bee-star-label-model-decoder"]', decide: decodeBeeLabel });

const fileInput = document.querySelector("[data-qr-file]");
const message = document.querySelector("[data-scan-message]");
const link = document.querySelector("[data-qr-link]");
const qrStatus = document.querySelector("#qr");
const officialHosts = ["beestarlabel.com", "www.beestarlabel.com", "beeindia.gov.in", "www.beeindia.gov.in"];

if (fileInput && fileInput.dataset.sbncQrInitialised !== "true") {
fileInput.dataset.sbncQrInitialised = "true";
fileInput.addEventListener("change", async () => {
  link.hidden = true;
  link.removeAttribute("href");
  const file = fileInput.files?.[0];
  if (!file) { message.textContent = "No image selected."; return; }
  if (!("BarcodeDetector" in window)) { message.textContent = "This browser cannot scan QR images here. Use the official BEE app or select QR status manually."; return; }
  try {
    const detector = new BarcodeDetector({ formats: ["qr_code"] });
    const codes = await detector.detect(await createImageBitmap(file));
    if (!codes.length) { qrStatus.value = "failed"; message.textContent = "No QR code was detected. Try a clear close-up or use the official BEE app."; return; }
    const raw = codes[0].rawValue;
    const url = new URL(raw);
    if (!officialHosts.includes(url.hostname)) { qrStatus.value = "failed"; message.textContent = `QR detected, but ${url.hostname} is not an official BEE domain recognized by this tool.`; return; }
    qrStatus.value = "verified";
    message.textContent = "Official BEE-domain QR detected. Open it and match the exact model details.";
    link.href = url.href;
    link.hidden = false;
  } catch {
    qrStatus.value = "failed";
    message.textContent = "The image could not be scanned. Use the official BEE app or select QR status manually.";
  }
});
}
}
boot();
document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvebridge-calculator-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-tool-slider')) {
    customElements.define(
      'sb-tool-slider',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.analyticsReady === 'true') return;
          this.dataset.analyticsReady = 'true';
          this.track = this.querySelector('[data-sb-slider-track]');
          this.previous = this.querySelector('[data-sb-slider-prev]');
          this.next = this.querySelector('[data-sb-slider-next]');
          this.current = this.querySelector('[data-sb-slider-current]');
          this.items = Array.from(this.track?.children || []);
          this.cards = Array.from(this.querySelectorAll('[data-sb-slider-card]'));
          this.viewAll = this.closest('.sb-home-tools')?.querySelector('[data-sb-slider-view-all]');

          this.cards.forEach((card, index) => {
            card.addEventListener('click', () => {
              this.publish('homepage_tool_clicked', {
                surface: 'homepage_calculator_slider',
                position: index + 1,
                category: card.dataset.sbSliderCategory || '',
                title: card.dataset.sbSliderTitle || '',
                destination: card.pathname || ''
              });
            });
          });

          this.viewAll?.addEventListener('click', () => {
            this.publish('homepage_view_all_clicked', {
              surface: 'homepage_calculator_slider',
              destination: this.viewAll.pathname || ''
            });
          });

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                this.publish('homepage_slider_viewed', {
                  surface: 'homepage_calculator_slider',
                  card_count: this.cards.length
                });
                this.observer.disconnect();
              },
              { threshold: 0.35 }
            );
            this.observer.observe(this);
          }

          if (!this.track || !this.previous || !this.next || this.items.length === 0) return;

          this.previous.addEventListener('click', () => this.move(-1));
          this.next.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.update();
        }

        move(direction) {
          const item = this.items[0];
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        update() {
          const item = this.items[0];
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item.getBoundingClientRect().width + gap;
          const index = Math.min(this.items.length - 1, Math.max(0, Math.round(this.track.scrollLeft / step)));
          this.current.textContent = String(index + 1);
          this.previous.disabled = index === 0;
          this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        }

        publish(eventName, eventData) {
          const qualifiedName = `solvebridge_tools:${eventName}`;
          const publishResult = window.Shopify?.analytics?.publish?.(qualifiedName, eventData);
          publishResult?.catch?.(() => {});

          if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({ event: qualifiedName.replace(':', '_'), ...eventData });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vukar-google-reviews"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('vukar-google-review-strip')) {
  customElements.define('vukar-google-review-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.rail = this.querySelector('.vgr__reviews');
      if (!this.rail || (window.Shopify && Shopify.designMode)) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motion.matches) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const originals = Array.from(this.rail.children);
      originals.forEach(card => {
        const copy = card.cloneNode(true);
        copy.dataset.reviewCopy = 'true';
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
        this.rail.append(copy);
      });
      this.firstCopy = this.rail.querySelector('[data-review-copy]');
      this.position = this.rail.scrollLeft;
      this.visible = false;
      this.holdUntil = 0;
      this.hovered = false;
      this.touching = false;
      this.rail.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.hovered = true; }, options);
      this.rail.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.rail.addEventListener('pointerdown', () => { this.touching = true; }, options);
      const release = () => { this.touching = false; this.holdUntil = performance.now() + 5000; this.position = this.rail.scrollLeft; };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.rail.addEventListener('wheel', () => { this.holdUntil = performance.now() + 5000; }, { ...options, passive: true });
      this.rail.addEventListener('scroll', () => { if (Math.abs(this.position - this.rail.scrollLeft) > 2) this.position = this.rail.scrollLeft; }, { ...options, passive: true });
      this.tick = time => {
        this.frame = null;
        if (!this.visible || document.hidden || !this.isConnected) { this.last = 0; return; }
        const elapsed = this.last ? Math.min(time - this.last, 50) : 0;
        this.last = time;
        if (!this.motion.matches && !this.hovered && !this.touching && !this.contains(document.activeElement) && time >= this.holdUntil) {
          const loop = this.firstCopy.offsetLeft - this.rail.firstElementChild.offsetLeft;
          if (loop > 0) {
            this.position = (this.position + elapsed * 0.02) % loop;
            this.rail.scrollLeft = this.position;
          }
        }
        this.frame = requestAnimationFrame(this.tick);
      };
      this.start = () => { if (!this.frame && this.visible && !document.hidden) { this.last = 0; this.frame = requestAnimationFrame(this.tick); } };
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.start(); });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.start, options);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.abort?.abort();
      this.querySelectorAll('[data-review-copy]').forEach(copy => copy.remove());
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vukar-purchase-assistant"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vukar-purchase-assistant')) {
  customElements.define('vukar-purchase-assistant', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.info = document.querySelector('.product__info-container');
      if (!this.info) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.bar = this.querySelector('.vpa-bar');
      this.price = this.querySelector('[data-vpa-price]');
      document.documentElement.dataset.vpaProduct = this.dataset.product;
      this.sync = () => {
        const anchor = this.info.querySelector('[id^="price-"]');
        if (this.dataset.showSummary === 'true' && anchor && !this.info.querySelector('.vpa-summary')) {
          anchor.after(this.querySelector('template').content.cloneNode(true));
        }
        const price = this.info.querySelector('.price:not(.price--on-sale) .price__regular .price-item--regular, .price.price--on-sale .price__sale .price-item--sale');
        const text = price?.textContent.trim();
        if (text && this.price.textContent !== text) this.price.textContent = text;
      };
      this.layout = () => {
        this.layoutFrame = null;
        const header = document.querySelector('.shopify-section-header-sticky, #shopify-section-header, header.header');
        const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0);
        this.style.setProperty('--vpa-header-offset', offset + 'px');
        document.documentElement.style.setProperty('--vpa-scroll-offset', offset + 'px');
        const height = matchMedia('(max-width: 749px)').matches ? this.bar.getBoundingClientRect().height + 12 : 0;
        this.style.minHeight = height + 'px';
        const purchaseNodes = [this.info.querySelector('[id^="price-"]'), this.info.querySelector('.vcod-open-btn'), this.info.querySelector('.product-form__buttons')].filter(Boolean);
        const optionsVisible = purchaseNodes.some(node => { const rect = node.getBoundingClientRect(); return rect.bottom > offset + 6 && rect.top < innerHeight - 40; });
        this.classList.toggle('vpa-at-options', optionsVisible);
      };
      const schedule = () => { if (!this.layoutFrame) this.layoutFrame = requestAnimationFrame(this.layout); };
      this.querySelector('[data-vpa-scroll]').addEventListener('click', () => {
        this.info.setAttribute('tabindex', '-1');
        this.info.focus({ preventScroll: true });
        this.info.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }, opts);
      window.addEventListener('scroll', schedule, { ...opts, passive: true });
      window.addEventListener('resize', schedule, opts);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.info, { childList: true, subtree: true, characterData: true });
      this.sync();
      this.layout();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
      this.info?.querySelector('.vpa-summary')?.remove();
      delete document.documentElement.dataset.vpaProduct;
      document.documentElement.style.removeProperty('--vpa-scroll-offset');
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
